/**
 * jQuery Finder Plugin
 * @author Danny McGee
 * @version 1.0
 * github.com/dannymcgee
 * 
 * Copyright 2018 Danny McGee
 * Released under the MIT License
 * https://opensource.org/licenses/MIT
 */
jQuery.extend({highlight:function(e,t,n,i){if(3===e.nodeType){var r=e.data.match(t);if(r){var a=document.createElement(n||"span");a.className=i||"highlight";var h=e.splitText(r.index);h.splitText(r[0].length);var s=h.cloneNode(!0);return a.appendChild(s),h.parentNode.replaceChild(a,h),1}}else if(1===e.nodeType&&e.childNodes&&!/(script|style)/i.test(e.tagName)&&(e.tagName!==n.toUpperCase()||e.className!==i))for(var l=0;l<e.childNodes.length;l++)l+=jQuery.highlight(e.childNodes[l],t,n,i);return 0}}),jQuery.fn.unhighlight=function(e){var t={className:"highlight",element:"span"};return jQuery.extend(t,e),this.find(t.element+"."+t.className).each((function(){var e=this.parentNode;e.replaceChild(this.firstChild,this),e.normalize()})).end()},jQuery.fn.highlight=function(e,t){var n={className:"highlight",element:"span",caseSensitive:!1,wordsOnly:!1};if(jQuery.extend(n,t),e.constructor===String&&(e=[e]),e=jQuery.grep(e,(function(e,t){return""!=e})),0==(e=jQuery.map(e,(function(e,t){return e.replace(/[-[\]{}()*+?.,\\^$|#\s]/g,"\\$&")}))).length)return this;var i=n.caseSensitive?"":"i",r="("+e.join("|")+")";n.wordsOnly&&(r="\\b"+r+"\\b");var a=new RegExp(r,i);return this.each((function(){jQuery.highlight(this,a,n.element,n.className)}))}; // DON'T FORGET TO REMOVE IT ONCE IT'S ADDED IN HTML SCRIPT (highlight.js)

$(function() {
	'use strict';
	const finder = {
		content: '[data-finder-content]',
	
		activate: () => {
			setTimeout(function () {
				// $('#finder').addClass('active');
				$('#finderInput').focus();
				if ($('#finderInput').val()) {
					finder.findTerm($('#finderInput').val());
				}
				$('#finderInput').on('input', function () {
					finder.findTerm($(this).val());
				});
			}, 50);
		},
	
		resultsCount: 0,
	
		currentResult: 0,
	
		findTerm: (term) => {
			// highlight results
			$(finder.content).unhighlight();
			$(finder.content).highlight(term);
			// count results
			finder.resultsCount = $('.highlight').length;
			if (finder.resultsCount) {
				// there are results, scroll to first one
				finder.currentResult = 1;
			} else {
				// no results
				finder.currentResult = 0;
			}
			// term not found
			if (!finder.resultsCount && term) {
				$('#finderInput').addClass('not-found');
			} else {
				$('#finderInput').removeClass('not-found');
			}
		},
	}
	if ($('#finderInput').length > 0) {
		setTimeout(function () {
			finder.findTerm($('#finderInput').val());
		}, 300);
	}
	$('.filter-btns .search-btn').on('click', function() {
		setTimeout(function () {
			finder.findTerm($('#finderInput').val());
		}, 300);
	});

	$("#finderInput").keyup(function(event) {
		if (event.which === 13) {
			setTimeout(function () {
				finder.findTerm($('#finderInput').val());
			}, 2000);
		}
	});
	// search finder
	$('.finder-input').on('click', function() {
		finder.activate();
	});
	// search finder
});